/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Generate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import DocumentTemplate from './DocumentTemplate/index'
import GenerateAction from './GenerateAction/index'
import LetterRecipientPicker from 'DesignSystem/LetterRecipientPicker/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Generate({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Generate"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let taskPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient.id',
})
let actionMetadataRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'action',
path: 'metadata.recipient_id',
})
let actionMetadataPostalAddressIdValueData = fromData.useDataValue({ viewPath,
context: 'action',
path: 'metadata.postal_address_id',
})
let onSave = fromHelpers.useOnSave({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Generate.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-2dpF7B': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Letter"
/>
<div
  data-testid="Generate.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<DocumentTemplate
  viewPath={`${viewPath}/DocumentTemplate`}
/>
<LetterRecipientPicker
  viewPath={`${viewPath}/LetterRecipientPicker`}
 offsetCrossAxis={-50}
 data="task.patient.id"
 patientId={taskPatientIdValueData}
 data="action.metadata.recipient_id"
 recipientId={actionMetadataRecipientIdValueData}
 data="action.metadata.postal_address_id"
 postalAddressId={actionMetadataPostalAddressIdValueData}
 onSave={onSave}
/>
<GenerateAction
  viewPath={`${viewPath}/GenerateAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}